<template>
  <div class="layout-sidebar">
    <!-- <div class="layout-sidebar__auth-container container">
      <AuthManager />
    </div> -->
    <div class="layout-sidebar__section container">
      <div class="layout-sidebar__row row">
        <div class="col-xl-9 mb-4">
          <router-view />
        </div>
        <div class="col-xl-3">
          <div class="layout-sidebar__row row">
            <div class="col-12 col-md-6 col-xl-12">
              <WidgetVk class="mb-5" />
            </div>
            <div class="col-12 col-md-6 col-xl-12">
              <VideosWidget />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import AuthManager from "@/components/profile/auth/AuthManager";
import WidgetVk from "@/components/widgets/WidgetVk";
import VideosWidget from "@/components/videos/VideosWidget";

export default {
  name: "LayoutDefault",
  components: {
    // AuthManager,
    VideosWidget,
    WidgetVk
  }
};
</script>

<style lang="scss">
.layout-sidebar {
  margin-top: -23px;

  &__section {
    margin-bottom: 60px;
    position: relative;
    z-index: 1;
  }

  &__auth-container {
    margin-bottom: 20px;
  }

  &__row {
    @include customGutter(7px);
  }

  @include breakpoint("md-and-down") {
    &__auth-container {
      margin-bottom: 0;
    }
    &__section {
      margin-bottom: 30px;
    }
  }
}
</style>
